module.exports = __webpack_public_path__ + "static/media/pamain-extrabold.52e42f98.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-extrabold.woff2
// module id = ./src/assets/fonts/pamain-extrabold.woff2
// module chunks = 6